import * as PIXI from 'pixi.js'

import { WorkAreaMapLocationNode } from 'modules/space_control/hooks/useWorkAreaMap'
import { TypeToIcon } from 'modules/space_control/lib/spaceicon'

export const Pin = (
  workSpaceLocation: WorkAreaMapLocationNode,
  options?: {
    onHover?: (workSpaceLocationId: number) => void
    onLeave?: (workSpaceLocationId: number) => void
    onClick?: (workSpaceLocationId: number) => void
  }
) => {
  const pinType = TypeToIcon(workSpaceLocation.workSpace?.workSpaceTypeValue || '')
  const workSpaceLocationId = workSpaceLocation.id
  if (!pinType || !workSpaceLocationId) return

  const container = new PIXI.Container()

  const shadow = new PIXI.Graphics()
  shadow.beginFill(0x000000, 0.3)
  shadow.drawRoundedRect(-20, -20, 48, 48, 16)
  shadow.endFill()
  shadow.filters = [new PIXI.filters.BlurFilter(4)]

  container.addChild(shadow)
  const alpha = workSpaceLocation.workSpace?.isFull ? 0.3 : 1.0
  const pin = new PIXI.Graphics()
  if (workSpaceLocation.workSpace?.isFull) {
    pin.beginFill('white')
    pin.drawRoundedRect(-24, -24, 48, 48, 16)
    pin.endFill()
  }
  pin.beginFill(pinType.color, alpha)
  pin.drawRoundedRect(-24, -24, 48, 48, 16)
  pin.endFill()

  const svgIconTexture = PIXI.Texture.from(pinType.icon.svg)
  const svgIcon = new PIXI.Sprite(svgIconTexture)
  svgIcon.anchor.set(0.5)
  svgIcon.width = pinType.icon.width
  svgIcon.height = pinType.icon.height
  svgIcon.alpha = alpha
  svgIcon.tint = pinType.icon.color
  pin.addChild(svgIcon)
  container.addChild(pin)

  const hoverScaleFactor = 1.1
  container.cursor = 'pointer'
  container.interactive = true
  container.on('pointerover', (event: PIXI.FederatedPointerEvent) => {
    const x = event.client.x
    const y = event.client.y
    const target = document.elementFromPoint(x, y)
    if (!target?.closest('canvas')) {
      options?.onLeave && options.onLeave(workSpaceLocationId)
      return
    }

    pin.tint = pinType.icon.color
    svgIcon.tint = 0xffffff
    svgIcon.alpha = 1
    container.scale.set(container.scale.x * hoverScaleFactor)
    options?.onHover && options.onHover(workSpaceLocationId)
  })
  container.on('pointerout', () => {
    pin.tint = '#ffffff'
    svgIcon.tint = pinType.icon.color
    svgIcon.alpha = alpha
    container.scale.set(container.scale.x / hoverScaleFactor)
    options?.onLeave && options.onLeave(workSpaceLocationId)
  })
  container.on('pointertap', () => {
    options?.onClick && options.onClick(workSpaceLocationId)
  })
  return container
}
